import { QuestionnaireFlowTypes } from 'constants/searchQuestionnaire'

export const initialQuestionnaireState: QuestionnaireState = {
  questionnaireFlowType: QuestionnaireFlowTypes.GENERIC,
  activePageIndex: 0,
  counselingTypeId: '',
  state: '',
  latitude: '',
  longitude: '',
  location: '',
  selectedInsurance: null,
  clientAgeGroups: [],
}

export const UPDATE_QUESTIONNAIRE = 'UPDATE_QUESTIONNAIRE'
export const UPDATE_PAGE_INDEX = 'UPDATE_PAGE_INDEX'
export const UPDATE_QUESTIONNAIRE_FLOWTYPE = 'UPDATE_QUESTIONNAIRE_FLOWTYPE'
export const RESET_QUESTIONNAIRE = 'RESET_QUESTIONNAIRE'
